import { useQuery } from '@tanstack/react-query';

import cruiseIqService, { type HealthReportQuery } from '~/services/cruises/CruiseIqService';

export const cruiseIqQueryKeys = {
  all: ['cruiseIQ'] as const,
  health: (params: HealthReportQuery) => [...cruiseIqQueryKeys.all, 'health', params] as const,
  predictions: (params: HealthReportQuery) => [...cruiseIqQueryKeys.all, 'predictions', params] as const,
};

export function useGetHealthReport(params: HealthReportQuery) {
  return useQuery({
    queryKey: cruiseIqQueryKeys.health(params),
    queryFn: () => cruiseIqService.getHealthReport(params),
  });
}

export function useGetHealthPredictions(params: HealthReportQuery) {
  return useQuery({
    queryKey: cruiseIqQueryKeys.predictions(params),
    queryFn: () => cruiseIqService.getHealthPredictions(params),
  });
}
